import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, Container, Row, Col } from "reactstrap";
import AuthNavbar from "components/Navbars/AuthNavbar";
import AuthHeader from "components/Headers/AuthHeader";
import userServices from "services/userServices";
import { useNotification } from "providers/NotificationProvider";
import { useTranslation } from "context/TranslationProvider";

const ListingConfirmation = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const { notify } = useNotification();

  const [loading, setLoading] = useState(true);
  const isExecutedRef = useRef(false);

  useEffect(() => {
    if (!token) {
      notify("error", t("page.listingConfirmation.toast.invalidToken", "Invalid or missing confirmation link."));
      setLoading(false);
      return;
    }

    if (isExecutedRef.current) return;
    isExecutedRef.current = true;

    userServices
      .handleListingEmailAction(token)
      .then((res) => {
        notify(
          "success",
          t(res?.data?.messageKey || "page.listingConfirmation.toast.success", res?.data?.message || "Listing action completed successfully.")
        );
        setTimeout(() => {
          navigate("/login", { replace: true });
        }, 2000);
      })
      .catch((err) => {
        const status = err?.response?.status;
        const apiError = err?.response?.data?.error;
        const msgKey = err?.response?.data?.messageKey;
        const message = err?.response?.data?.message;

        if (status === 400) {
          notify("warning", t(msgKey || apiError || "page.listingConfirmation.toast.invalidLink", message || "This link is no longer valid."));
        } else if (status === 404) {
          notify("error", t(msgKey || "page.listingConfirmation.toast.notFound", message || "Listing not found."));
        } else {
          notify(
            "error",
            t(msgKey || apiError || "page.listingConfirmation.toast.error", message || "Something went wrong. Please try again later.")
          );
        }
      })
      .finally(() => setLoading(false));
  }, [token, notify, navigate, t]);

  return (
    <>
      <AuthNavbar
        logo={{
          innerLink: "/login",
          imgSrc: require("assets/img/images/logo.png"),
          imgAlt: "...",
        }}
      />

      <AuthHeader
        title="Listing Confirmation"
        lead="Processing your request…"
      />

      <Container className="mt--8 pb-5">
        <Row className="justify-content-center">
          <Col lg="5" md="7">
            <Card className="bg-secondary border-0 mb-0">
              <CardBody className="px-lg-5 py-lg-5 text-center">
                {loading ? (
                  <div className="text-muted">Please wait…</div>
                ) : (
                  <>
                    <p className="text-muted mb-4">
                      You may safely close this page.
                    </p>
                    <Button color="warning" tag={Link} to="/login">
                      Go to Login
                    </Button>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ListingConfirmation;
